import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { keys } from '@/lib/queryKeys';
import { fetchBillCreditNotes } from './api';

export function useBillCreditNotes(billId: number | null) {
  const { branchVersion } = useAuth();
  return useQuery({
    queryKey: [...keys.billing.creditNotes(billId ?? 0), branchVersion],
    queryFn: () => fetchBillCreditNotes(billId as number),
    enabled: billId != null,
  });
}
